import { IconButton } from "@seneca/senekit";

type Props = {
  closeToast?: () => void;
  onCloseClick?: () => void;
};

export default function CloseButton({ closeToast, onCloseClick }: Props) {
  const handleClick = () => {
    closeToast && closeToast();
    onCloseClick && onCloseClick();
  };

  return (
    <IconButton
      iconName="cross"
      blend
      tone="neutral"
      size="small"
      onClick={handleClick}
      accessibilityLabel="Close"
    />
  );
}
